module.exports = __webpack_public_path__ + "img/mv_illustration_sp.38b99057.svg";